import { TENNAT_API_URL, ADMIN_API_URL } from '@services/.env'
import { by, get } from '@services/custom.service'
import { BaseService } from '@services/base.service'

export class PaymentMethods extends BaseService {
  static getAllAccounts(commit) {
    return get(`${TENNAT_API_URL}payment_gateway/accounts`)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  }

  static getAllSubsriptionPlans(commit) {
    return get(`${TENNAT_API_URL}payment_gateway/subscription_plans`)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
  }
  static getUserCount(commit) {
    return get(`${TENNAT_API_URL}users_count`)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
  }
  static createSubscription(data, commit) {
    return by(`${TENNAT_API_URL}payment_gateway/stripe/new_subscription`, data)
      .then((response) => {
        commit(
          'toast/NEW',
          { message: 'Redirect to stripe page to create subscription', type: 'success' },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
  }

  static sendContactUsRequest(data, commit) {
    return by(`${ADMIN_API_URL}contact_us_messages`, data)
      .then((response) => {
        commit(
          'toast/NEW',
          {
            message: 'Your Query has been received. Our team will get back to you soon.',
            type: 'success',
          },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        commit(
          'toast/NEW',
          {
            message: 'There is an error in form submission. Please try again later.',
            type: 'error',
          },
          { root: true },
        )
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static upgradeSubscription(data, commit) {
    return by(`${TENNAT_API_URL}payment_gateway/stripe/manage_subscriptions`, data)
      .then((response) => {
        commit(
          'toast/NEW',
          { message: 'Redirect to stripe page to manage subscription', type: 'success' },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static createStripeStandardAccount(data, commit) {
    return by(`${TENNAT_API_URL}payment_gateway/stripe/accounts`, data)
      .then((response) => {
        commit(
          'toast/NEW',
          { message: 'User stripe account created successfully', type: 'success' },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
  }

  static onBoardUser(data, commit) {
    return by(`${TENNAT_API_URL}payment_gateway/stripe/accounts/onboarding`, data)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  }

  static deAuthorize(data, commit) {
    return by(`${TENNAT_API_URL}payment_gateway/stripe/accounts/deauthorize`, data)
      .then((response) => {
        commit(
          'toast/NEW',
          { message: 'User stripe account deauthorized successfully', type: 'success' },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static payStudentFees(data, commit) {
    return by(`${TENNAT_API_URL}student_online_fee_pay`, data)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }
}
